package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.addQueryParam
import com.fsryan.foundation.net.client.queryParamValues
import com.fsryan.foundation.net.client.replacePathParams

class WMPresignedJDFileUrlsRequestBuilder: FSAuthenticatedRequestBuilder<WMPresignedJDFileUrlsRequestBuilder, Nothing>() {

    private val mixIds = mutableSetOf<String>()

    fun addMixId(mixId: String): WMPresignedJDFileUrlsRequestBuilder {
        mixIds.add(mixId)
        return self()
    }

    override fun applyFrom(request: FSRequest<Nothing>): WMPresignedJDFileUrlsRequestBuilder {
        request.queryParamValues("mid").forEach { mixId ->
            mixIds.add(mixId)
        }
        return super.applyFrom(request)
    }

    override fun build(): FSRequest<Nothing> {
        method(FSRequest.Method.Get)
        removeQueryParams("mid")
        mixIds.forEach { mixId ->
            addQueryParam("mid", mixId)
        }
        acceptJson()
        replacePathParams("api", "v1", "jd-file-urls")
        return super.build()
    }

    override fun clear(): WMPresignedJDFileUrlsRequestBuilder {
        mixIds.clear()
        return super.clear()
    }

    override fun self(): WMPresignedJDFileUrlsRequestBuilder = this
}